// extracted by mini-css-extract-plugin
export default {"renewDialogContent":"styles_renewDialogContent__eUmL0","renewDialogButtons":"styles_renewDialogButtons__tfCV2"};